import { bizTypeMap } from '../../bizTypeMapping'
import { soapPost } from '../../ajaxSoap'
import axios from 'axios'
import getPrefix from '@/api/apiConfig.js'

export const queryFrontReportData = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.queryFrontReport, queryDoc, {noShowError: true})
    .done(function (data) {
      ret = data
    })
  return ret
}

// fop控单量指标
export const queryTop5ScheduleOwner = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.queryTop5ScheduleOwner, queryDoc, {noShowError: true})
    .done(function (data) {
      ret = data
    })
  return ret
}

export const callFopReleaseOrder = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.callFopReleaseOrder, queryDoc, {noShowError: true})
    .done(function (data) {
      ret = data
    })
  return ret
}
// csat是否弹出
export const queryCsatPopupIsRequired = async (data) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${getPrefix().mcsApi}/user/queryCsatPopupIsRequired`,
      data: data
    });
    return response.data;
  } catch (error) {
    console.error('Error in queryCsatPopupIsRequired:', error);
    throw error; // Re-throw the error so the caller can handle it
  }
};

// csat是否弹出
export const queryNpsPopupIsRequired = async (data) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${getPrefix().mcsApi}/user/queryNpsPopupIsRequired`,
      data: data
    });
    return response.data;
  } catch (error) {
    console.error('Error in queryCsatPopupIsRequired:', error);
    throw error; // Re-throw the error so the caller can handle it
  }
};

// csat记录接口
export const receiveUserCsat = async (data) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${getPrefix().mcsApi}/user/receiveUserCsat`,
      data: data
    });
    return response.data;
  } catch (error) {
    console.error('Error in queryCsatPopupIsRequired:', error);
    throw error; // Re-throw the error so the caller can handle it
  }
};